$('.modal').fitVids();
$('.modal-open').on('click', function(e){
  e.preventDefault();
  $($(this).attr('href')).addClass('shown');
  $('.modal-close').focus();
});
$('.modal-close').on('click', function(e){
  e.preventDefault();
  $(this).closest('.modal').removeClass('shown');
});